import React, { useState } from 'react'

import { IconButton } from '@mui/material'
import { useSnackbar } from "../snackbar/snackbar"

import styles from './gallery-item.module.css'

import VideoPlayerDialog from '../dialogs/video-player'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import GalleryMoreMenu from '../forms/gallery-more-menu'
import useRefMenu from '../../hooks/useRefMenu'

import DeleteGallery from '../dialogs/delete-gallery'
import { deleteGalleryEntry } from '../../api-client/data'
import { formatDateTimeFancy } from '../../util/time'

const GalleryThumbnail = ({ thumbnail, galleryMoreMenu, path, setIsPlayerOpen }) => {
    return (
        <div
            className={styles.galleryCard}
            style={{ backgroundImage: `url('${thumbnail}')` }}
            onClick={() => setIsPlayerOpen(true)}
            ref={galleryMoreMenu.ref}
        >
        </div>
    )
}

const GalleryItem = ({ title, thumbnail, id, path, videoPath, refreshGallery, ...rest }) => {
    const [isPlayerOpen, setIsPlayerOpen] = useState(false)
    const galleryMoreMenu = useRefMenu()
    const { enqueueSnackbar } = useSnackbar()
    const [showDelete, setShowDelete] = useState(false)

    const deleteGalleryItem = async () => {
        setShowDelete(false)
        try {
            await deleteGalleryEntry(id)
            enqueueSnackbar("Successfully deleted", {
                variant: "success",
            })
        } catch {
            enqueueSnackbar("Error deleting, please try again later", {
                variant: "error",
            })
        }

        refreshGallery()
    }

    const handleMenuStartDelete = () => {
        galleryMoreMenu.setShow(false)
        setShowDelete(true)
    }

    return (
        <div className={styles.galleryItem}>
            <DeleteGallery show={showDelete} setShow={setShowDelete} handleDelete={deleteGalleryItem} />
            <GalleryThumbnail
                setIsPlayerOpen={setIsPlayerOpen}
                path={path||videoPath}
                thumbnail={thumbnail}
                galleryMoreMenu={galleryMoreMenu}
            />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 38 }}>
                <div className={styles.galleryTitle}>
                    <div>{title}</div>
                    {
                        !!rest?.createdAt && (
                            <div style={{
                                fontSize: 15,
                                color: `var(--text-secondary)`
                            }}>
                                {formatDateTimeFancy(new Date(rest?.createdAt))}
                            </div>
                        )
                    }
                </div>
                <div className={styles.galleryIconButton}>
                    <IconButton onClick={() => galleryMoreMenu.setShow(true)}>
                        <MoreVertIcon style={{ color: `var(--text-primary)`}}/>
                    </IconButton>
                </div>
            </div>
            <VideoPlayerDialog
                title={title}
                src={path || videoPath}
                isOpen={isPlayerOpen}
                onClose={() => setIsPlayerOpen(false)}
            />
            <GalleryMoreMenu
                buttonRef={galleryMoreMenu.ref}
                open={galleryMoreMenu.show}
                setOpen={galleryMoreMenu.setShow}
                onDelete={handleMenuStartDelete}
            />
        </div>
    )
}
export default GalleryItem